import React from 'react';
import './Skeleton.css';

export const CardSkeleton = () => {
  return (
    <div className="skeleton-box skeleton-card"></div>
  );
};

export const CardSkeletonGrid = ({ count = 6 }) => {
  return (
    <div className="skeleton-grid">
      {Array.from({ length: count }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
};
